import React, { Component } from 'react';

export default function wrapGrid (Comp, styles) {
	return class extends Component {
		render () {
			const props = this.props || {};

			return (
				<div className="grid-x">
					<div className="auto cell" style={styles}>
						<Comp { ...props } />
					</div>
				</div>
			);
		}
	}
}
